import { Card } from "~/components/v4/shadcn/Card";
import { ReactNode } from "react";

type SharedHomeHeaderProps = {
    title: ReactNode;
    smallTitle?: ReactNode;
    subTitle: ReactNode;
    smallSubTitle?: ReactNode;
    actionsBar: ReactNode;
    squareColor: string;
    squareIcon: ReactNode;
    mobileActionsBar?: ReactNode;
};

const SharedHomeHeader = ({
    title,
    smallTitle,
    subTitle,
    smallSubTitle,
    actionsBar,
    squareColor,
    squareIcon,
    mobileActionsBar,
}: SharedHomeHeaderProps) => {
    return (
        <Card className="flex flex-col items-start bg-v3-N500 p-6">
            {/* Mobile View */}
            <div className="w-full md:hidden">
                <div className="mb-3 flex items-start gap-3">
                    {/* Icon */}
                    <div
                        className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md"
                        style={{ backgroundColor: squareColor }}
                    >
                        <div style={{ transform: "scale(0.45)" }}>
                            {squareIcon}
                        </div>
                    </div>

                    {/* Title and subtitle together in a column */}
                    <div className="flex flex-col">
                        <span className="text-[16px] font-[400]">
                            {smallTitle || title}
                        </span>
                        <span className="text-[14px] font-[400] text-[#A3A8B4]">
                            {smallSubTitle || subTitle}
                        </span>
                    </div>
                </div>

                {/* Mobile Actions */}
                {mobileActionsBar}
            </div>

            {/* Desktop View */}
            <div className="hidden w-full md:flex md:flex-row md:items-center md:gap-4">
                {/* Left Square / Icon */}
                <div
                    className="flex h-[102px] w-[102px] flex-shrink-0 items-center justify-center rounded-md"
                    style={{ backgroundColor: squareColor }}
                >
                    {squareIcon}
                </div>

                {/* Right content */}
                <div className="flex w-full flex-col">
                    <span className="w-full break-words font-[400]">
                        {title}
                    </span>
                    <span className="w-full break-words text-sm font-[400] text-[#A3A8B4]">
                        {subTitle}
                    </span>
                    <div className="flex flex-wrap items-center gap-4 pt-2">
                        {actionsBar}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default SharedHomeHeader;
